/**
 * BP-14 §9's `prepaid.*` strings.
 *
 * A flat object, the shape `features/colour` and `features/photos` use;
 * BP-19 is the BP that adds Hindi, Marathi and Gujarati and moves every
 * feature's strings at once.
 *
 * **The one that matters most is `expiringOn`.** A prepaid balance with a
 * silent expiry date is the part of this product most likely to make
 * somebody angry, and the honest design is to say it on the screen they
 * look at rather than only in a reminder they may not get.
 */
export const strings = {
  loading: 'Loading…',
  failed: 'That could not be loaded.',

  packagesTitle: 'Packages',
  packagesHint: 'Prepaid bundles of services. A package somebody bought keeps its definition.',
  packagesNone: 'No packages yet.',
  plansTitle: 'Membership plans',
  plansNone: 'No membership plans yet.',

  name: 'Name',
  price: 'Price (₹)',
  validity: 'Valid for (days)',
  sac: 'SAC code',
  gst: 'GST rate (%)',
  service: 'Service',
  qty: 'How many',
  period: 'Period',
  discount: 'Member discount (%)',
  bonus: 'Joining bonus (₹)',
  add: 'Add',
  addFailed: 'That could not be saved.',
  deactivate: 'Take off sale',
  reactivate: 'Put back on sale',
  inactive: 'Off sale',

  period_monthly: 'Monthly',
  period_quarterly: 'Quarterly',
  period_yearly: 'Yearly',

  holdingsTitle: 'Prepaid',
  noHoldings: 'This client holds no packages, membership or balance.',
  creditsTitle: 'Package credits',
  creditLeft: '{{left}} of {{total}} left, until {{when}}',
  membershipTitle: 'Membership',
  membershipRuns: 'Runs {{from}} to {{to}}',
  membershipUsed: 'Benefit given {{count}} time(s)',
  noMembership: 'No membership.',
  cancel: 'Cancel membership',
  cancelUsed: 'A membership that has given a discount cannot be cancelled.',
  refund: 'Refund the unused part',
  refunded: '{{amount}} went back on the wallet.',

  walletTitle: 'Wallet',
  balance: 'Balance',
  expiringOn: '{{amount}} expires on {{when}}',
  nothingExpiring: 'Nothing expires in the next month.',
  historyTitle: 'History',
  kind_topup: 'Top-up',
  kind_bonus: 'Bonus',
  kind_redeem: 'Spent',
  kind_refund: 'Refund',
  kind_expire: 'Expired',
  kind_adjust: 'Correction',

  sellTitle: 'Sell',
  sellPackage: 'Sell a package',
  sellMembership: 'Sell a membership',
  topUp: 'Add to the wallet',
  amount: 'Amount (₹)',
  sell: 'Sell',
  sold: 'Done.',
  sellFailed: 'That sale was refused.',
  bonusEarned: 'A bonus of {{amount}} was added.',

  correctTitle: 'Correct the balance',
  correctHint: 'A correction is a new line with a reason, never an edit to an old one.',
  correctAmount: 'Amount (₹, negative to take away)',
  reason: 'Reason',
  correct: 'Record the correction',
  reasonRequired: 'A correction needs a reason.',

  spendTitle: 'Prepaid on this bill',
  spendNone: 'Nothing on this bill can be paid from a package.',
  spend: 'Use a credit',
  spendFailed: 'That credit could not be used.',
  spentTotal: 'The bill now comes to {{amount}}.',

  myWalletTitle: 'My balance',
  myCreditsTitle: 'My packages',
  myMembershipTitle: 'My membership',
  myNothing: 'Nothing prepaid yet.',
} as const;
